import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const useWarehouses = (enabled?: boolean) => {
  const api = useAPI();

  return useQuery({
    queryKey: ['warehouses'],
    queryFn: () => api.getBackPlacesAll(),
    enabled,
  });
};
